import { read } from "./read"
import { write } from "./write"

export const swProjectApplication = {
  write,
  read,
}
